import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import type { PropertyGroupResponse } from '@/shared/api';

type ObjectEditTarget = '/property-groups/$id/stammdaten' | '/property-groups/$id/hausordnung';

/**
 * Nach dem Speichern des Objekts. Gleiche Adressen führt der Server ohne Rückfrage zusammen —
 * dann existiert dieses Objekt nicht mehr, und der Bereich öffnet sich am überlebenden Objekt.
 */
export function useObjectEditSaved(groupId: string, target: ObjectEditTarget) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return async (saved: PropertyGroupResponse) => {
    // Erst weg vom verschwundenen Objekt, dann nachladen — sonst fragt das Nachladen genau das
    // Objekt ab, das es nicht mehr gibt, und der Arbeitsraum zeigt kurz einen Ladefehler.
    if (saved.id !== groupId) {
      await navigate({ to: target, params: { id: saved.id }, replace: true });
    }
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ['property-groups'] }),
      queryClient.invalidateQueries({ queryKey: ['properties'] }),
    ]);
  };
}
